export default "__VITE_ASSET__xaAtpUXc__"